import { createStyles, makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      alignSelf: 'baseline',
      marginLeft: 5,
    },
  }),
);

export default useStyles;
